/**
 * History crumb ("back to the list") next to the hierarchy trail.
 *
 * The trail itself is hierarchical and identical for every visitor — that is what
 * search engines index and what tells a shopper where the product lives. It does not,
 * and should not, follow where the visitor came from. This adds the missing half:
 * one control that returns to the exact list the visitor was browsing, filters and
 * sorting intact.
 *
 * Deliberately client-side only: nothing here is server-rendered, the link is
 * rel="nofollow", and it never appears in the JSON-LD. A crawler must never see a
 * session-dependent URL in the trail.
 */
(function () {
  var KEY = 'r69:last-collection';

  function templateOf(root) {
    var main = (root || document).querySelector('main[data-template]');
    return main ? main.getAttribute('data-template') : '';
  }

  function remember() {
    try {
      sessionStorage.setItem(KEY, window.location.pathname + window.location.search);
    } catch (e) {
      /* private mode / storage disabled — the trail still works, only "back" is lost */
    }
  }

  function offerBack(root) {
    var back = (root || document).querySelector('[data-r69-crumbs-back]');
    if (!back) return;

    var stored = null;
    try {
      stored = sessionStorage.getItem(KEY);
    } catch (e) {
      return;
    }
    if (!stored) return;

    // Only offer the return trip when the remembered list actually contains this
    // product — otherwise "back to the list" would drop the visitor somewhere they
    // never were.
    var path = stored.split('?')[0].replace(/\/$/, '');
    var known = (back.getAttribute('data-collection-urls') || '').split(',');
    var match = false;
    for (var i = 0; i < known.length; i++) {
      if (known[i] && known[i].replace(/\/$/, '') === path) {
        match = true;
        break;
      }
    }
    if (!match) return;

    back.setAttribute('href', stored);
    back.removeAttribute('hidden');
  }

  function init(root) {
    var template = templateOf(root);
    if (template === 'collection') remember();
    else if (template === 'product') offerBack(root);
    else if (template) {
      // Left the browsing flow entirely — drop the memory so a stale list cannot
      // resurface days later.
      try {
        sessionStorage.removeItem(KEY);
      } catch (e) {}
    }
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  // Horizon morphs the page on navigation and re-emits section load.
  document.addEventListener('shopify:section:load', function () { init(document); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(document); });
})();
